<ng-content select="sub-navigation" />
<div class="view-switcher-wrapper">
  <ng-content select="view-switcher" />
</div>
<div class="sub-navigation-left">
  @if (isDisplaySearch) {
    <button class="search-button" (click)="openSearchDialog()" [matTooltip]="'TAB.SEARCH' | translate">
      <div class="button-content">
        <mat-icon>search</mat-icon>
        @if (!isMac) {
          <p class="button-text-ctrl">Ctrl K</p>
        } @else {
          <div class="button-text-cmd">
            <mat-icon>keyboard_command_key</mat-icon>
            <p>+ K</p>
          </div>
        }
      </div>
    </button>

    <notifications-popup />
  }

  @if (isDisplayLogout || $account()?.supervisor) {
    <button
      matIconButton
      [disableRipple]="true"
      (click)="logout()"
      [matTooltip]="'CONNECTION.LOGOUT' | translate">
      <mat-icon>logout</mat-icon>
    </button>
  }
</div>
